import { Link } from "react-router-dom";
import { genres, siteInfo } from "@/mocks/dramas";

const QUICK_LINKS = [
  { label: "首页", to: "/" },
  { label: "热门榜单", to: "/ranking" },
  { label: "新剧速递", to: "/ranking?tab=new" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-foreground-800">
      <div className="mx-auto max-w-page px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-950">
                <i className="ri-movie-2-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-800/90">
              汇总黑料短剧排行榜、热门短剧与新剧推荐，按口味挑片不踩雷，同类好剧持续更新。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-foreground-800/70">
              <i className="ri-refresh-line text-accent-400" aria-hidden="true"></i>
              {siteInfo.updateNote}
            </p>
          </div>

          <nav aria-label="页脚快速导航">
            <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
              <Link to="/" className="hover:text-accent-400 cursor-pointer transition-colors">快速导航</Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {QUICK_LINKS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-foreground-800/90 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="页脚口味分类">
            <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
              <Link to="/ranking" className="hover:text-accent-400 cursor-pointer transition-colors">热门口味</Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {genres.map((g) => (
                <li key={g.slug}>
                  <Link
                    to={`/ranking?category=${g.slug}`}
                    className="text-foreground-800/90 transition-colors hover:text-accent-400 cursor-pointer"
                  >
                    {g.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
              <Link to="/about" className="hover:text-accent-400 cursor-pointer transition-colors">联系与订阅</Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-800/90">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" aria-hidden="true"></i>
                <a href={`mailto:${siteInfo.email}`} className="hover:text-accent-400 cursor-pointer transition-colors">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" aria-hidden="true"></i>
                <span>每日 10:00 更新</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" aria-hidden="true"></i>
                <span>线上内容平台</span>
              </li>
            </ul>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-label font-medium text-background-950 transition-colors hover:bg-accent-400 cursor-pointer"
            >
              <i className="ri-notification-3-line" aria-hidden="true"></i>
              订阅上新
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-foreground-800/30 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-800/70">
            © 2026 {siteInfo.name} · 短剧内容信息与排行整理
          </p>
          <p className="text-xs leading-relaxed text-foreground-800/60 sm:text-right">
            本站内容为剧集信息整理与推荐，作品版权归原权利人所有。
          </p>
        </div>
      </div>
    </footer>
  );
}